// extracted by mini-css-extract-plugin
export default {"header-icon-wrapper":"header-icon-wrapper-13c7","header-item-wrapper":"header-item-wrapper-8be0"};